import { render, staticRenderFns } from "./quadroHonra.vue?vue&type=template&id=fde30596&"
import script from "./quadroHonra.vue?vue&type=script&lang=js&"
export * from "./quadroHonra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports